import { config } from "../config";
import { tokenManager } from "./tokenManager";
import { SessionInfo } from "@/types/auth";

export const getSessions = async (): Promise<SessionInfo[]> => {
  try {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/sessions`, {
      method: 'GET',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to fetch sessions');
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

export const revokeSession = async (sessionId: number): Promise<void> => {
  try {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/sessions/${sessionId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Failed to revoke session');
    }
  } catch (error) {
    throw error;
  }
};